import { render, staticRenderFns } from "./CountdownTimer.vue?vue&type=template&id=fa18a55e&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"
import style0 from "./CountdownTimer.vue?vue&type=style&index=0&id=fa18a55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa18a55e",
  null
  
)

export default component.exports